import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column align-items-center gap-3"
}
const _hoisted_2 = ["disabled"]
const _hoisted_3 = {
  key: 2,
  class: "text-start fw-bold mb-4 mt-2 text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _cache[1] || (_cache[1] = _createElementVNode("p", { class: "fw-bold fs-5 ps-0 mb-0" }, " Please attach all PDF documents related to the case. ", -1)),
          _createVNode(_component_file_upload, {
            onFilesReady: _ctx.onFilesReady,
            onFilesNotReady: _ctx.onFilesNotReady
          }, null, 8, ["onFilesReady", "onFilesNotReady"]),
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "fw-bold fs-5 ps-0 mb-0" }, " Once all documents have been uploaded, click \"Start Processing\". ", -1)),
          _createElementVNode("button", {
            class: "btn btn-primary fw-bold align-self-center",
            disabled: !_ctx.filesReady,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.startProcessing && _ctx.startProcessing(...args)))
          }, " Start Processing ", 8, _hoisted_2)
        ]))
      : (_openBlock(), _createBlock(_component_loading_spinner, { key: 1 })),
    (_ctx.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 64))
}